import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OtpSignUpComponent } from './page/otp-sign-up/otp-sign-up.component';
import { SignUpComponent } from './page/sign-up/sign-up.component';
import { VerifyNumberComponent } from './page/verify-number/verify-number.component';
import { TotpEnrollComponent } from './page/totp-enroll/totp-enroll.component';
import { SignUpV2Component } from './page/sign-up-v2/sign-up-v2.component';
import { EmailOtpVerifyComponent } from './page/email-otp-verify/email-otp-verify.component';

const routes: Routes = [
  {
    path: '',
    component: SignUpComponent
  },
  {
    path: 'v2',
    component: SignUpV2Component
  },
  {
    path: 'otp',
    component: OtpSignUpComponent
  },
  {
    path: 'verify-number',
    component: VerifyNumberComponent
  },
  {
    path: 'email-otp-verify',
    component: EmailOtpVerifyComponent
  },
  {
    path: 'totp-enroll',
    component: TotpEnrollComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignUpRoutingModule { }
